module.exports = __webpack_public_path__ + "img/bo.f1a6e5d0.png";